import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import PhotoIcon from '@mui/icons-material/Photo';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import StarsIcon from '@mui/icons-material/Stars';
import MainCard from './cards/MainCard';
import { Box, Grid, Tab, Tabs, Backdrop, CircularProgress, Typography, Button, CardMedia } from '@mui/material';
import { useTheme, makeStyles } from '@material-ui/styles';
import ImagePlaceholder from './cards/Skeleton/ImagePlaceholder';
import ServiceInformation from 'src/components/ServiceInformation';
import ServicePhotos from 'src/components/ServicePhotos';
import ServiceVehicles from 'src/components/ServiceVehicles';
import AdfScannerIcon from '@mui/icons-material/AdfScanner';
import PlaceIcon from '@mui/icons-material/Place';
import ServiceDocumentation from 'src/components/ServiceDocumentation';
import ServicePerformance from 'src/components/ServicePerformance';
import ServiceLocation from 'src/components/ServiceLocation';
import ServiceForms from 'src/components/ServiceForms';
import { getUser } from 'src/utils/Common';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import BeratSvgCard from '../views/BeratManagement/YSBeratKunye'

function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box
                    sx={{
                        p: 0
                    }}
                >
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const tabOptions = [
    {
        icon: <AccountCircleTwoToneIcon stroke={1.5} size="17px" />,
        label: 'Servis Bilgileri'
    },
    {
        icon: <PhotoIcon stroke={1.5} size="17px" />,
        label: 'Servis Fotoğrafları'
    },
    {
        icon: <DriveEtaIcon stroke={1.5} size="17px" />,
        label: 'Servis Araçları'
    },
    {
        icon: <StarsIcon stroke={1.5} size="17px" />,
        label: 'Performans Göstergeleri'
    },
    {
        icon: <AdfScannerIcon stroke={1.5} size="17px" />,
        label: 'Servis Dokümanları'
    },
    {
        icon: <DynamicFormIcon stroke={1.5} size="17px" />,
        label: 'Servis Formları'
    },
    {
        icon: <PlaceIcon stroke={1.5} size="17px" />,
        label: 'Servis Konumu'
    },
    {
        icon: <CardMembershipIcon stroke={1.5} size="17px" />,
        label: 'Servis Beratı'
    }
];



const ServiceDetailCard = ({ ServiceShopId, ServiceShopName, IsRedirected, ServiceShopAddress, EmployeeRole, TopServiceShopCode, Cover }) => {
    const theme = useTheme();
    const [isLoading, setLoading] = useState(true);
    const [value, setValue] = useState(0);
    const { borderRadius } = 8;
    const serviceShopName = ServiceShopName;
    const SessionUser = getUser();

    // Cover değiştikçe güncelle
    const [coverSrc, setCoverSrc] = useState(Cover);
    useEffect(() => {
        setCoverSrc(Cover);
    }, [Cover]);

    useEffect(() => {
        setLoading(false);
    }, []);

    useEffect(() => {
        if (IsRedirected) {
            setValue(2); // Set the tab to 'Servis Araçları' if the condition is met
        }
    }, [IsRedirected]);

    const useStyles = makeStyles(() => ({
        ul: {
            '& .MuiPaginationItem-root': {
                '&.Mui-selected': {
                    background: '#FF9800',
                    color: 'white',
                    borderRadius: '50%',
                },
            },
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
    }));



    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const classes = useStyles();

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <MainCard
                    contentSX={{
                        p: 1.5,
                        paddingBottom: '0px !important',
                        [theme.breakpoints.down('lg')]: {
                            textAlign: 'center'
                        }
                    }}
                >
                    {isLoading ? (
                        <ImagePlaceholder
                            sx={{
                                borderRadius: `${borderRadius}px`,
                                overflow: 'hidden',
                                mb: 3,
                                height: { xs: 85, sm: 150, md: 260 }
                            }}
                        />
                    ) : (
                        <Box
                            sx={{
                                width: '100%',
                                mb: 2,
                                px: 0
                            }}
                        >
                            <CardMedia
                                component="img"
                                image={coverSrc}
                                sx={{
                                    width: '100%',
                                    height: '400px',
                                    objectFit: 'contain',
                                    background: '#f0f0f0'
                                }}
                            />
                        </Box>
                    )}
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Box sx={{ alignItems: 'center' }}>

                            </Box>
                            <Grid container justifyContent="flex-end" alignItems="center">
                                <Tabs
                                    value={value}
                                    variant="scrollable"
                                    onChange={handleChange}
                                    TabIndicatorProps={{
                                        sx: {
                                            backgroundColor: '#FF9800',
                                        },
                                    }}
                                    sx={{
                                        marginTop: 2.5,
                                        '& .MuiTabs-flexContainer': {
                                            border: 'none'
                                        },
                                        '& .MuiTab-root': {
                                            minHeight: 'auto',
                                            minWidth: 10,
                                            py: 1.5,
                                            px: 1,
                                            mr: 2.25,
                                            color: 'grey.700',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        },
                                        '& .MuiTab-root.Mui-selected': {
                                            color: '#FF9800'
                                        },
                                        '& .MuiTab-root > svg': {
                                            marginBottom: '4px !important',
                                            mr: 1.25
                                        }
                                    }}
                                >
                                    {tabOptions.map((option, index) => (
                                        <Tab
                                            key={index}
                                            icon={option.icon}
                                            label={option.label}
                                            {...a11yProps(index)}
                                        />
                                    ))}
                                </Tabs>
                            </Grid>
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
            <Grid item xs={12}>
                <TabPanel value={value} index={0}>
                    <ServiceInformation ServiceShopId={ServiceShopId} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <ServicePhotos
                        ServiceShopId={ServiceShopId}
                        ServiceShopFullName={ServiceShopName}
                    />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ServiceVehicles
                        ServiceShopId={ServiceShopId}
                        ServiceShopFullName={ServiceShopName}
                    />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <ServicePerformance
                        ServiceShopId={ServiceShopId}
                        ServiceShopFullName={ServiceShopName}
                        TopServiceShopCode={TopServiceShopCode}
                        EmployeeRole={EmployeeRole}
                    />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <ServiceDocumentation
                        ServiceShopId={ServiceShopId}
                        ServiceShopFullName={ServiceShopName}
                    />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <ServiceForms
                        ServiceShopId={ServiceShopId}
                        ServiceShopFullName={ServiceShopName}
                    />
                </TabPanel>
                <TabPanel value={value} index={6}>
                    <ServiceLocation
                        ServiceShopId={ServiceShopId}
                        ServiceShopFullName={ServiceShopName}
                        ServiceShopAddress={ServiceShopAddress}
                    />
                </TabPanel>
                <TabPanel value={value} index={7}>
                    <BeratSvgCard
                        ServiceShopId={ServiceShopId}
                        ServiceShopName={ServiceShopName}
                    />
                </TabPanel>
            </Grid>
        </Grid>
    );
};

export default ServiceDetailCard;